import { render, staticRenderFns } from "./mySeamlessScroll.vue?vue&type=template&id=0cfab506"
import script from "./mySeamlessScroll.vue?vue&type=script&lang=js"
export * from "./mySeamlessScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports